export default "__VITE_ASSET__DSfx9_0f__"